import { useState } from "react";

const FaqRow = ({ q, a, i, open, onToggle }) => (
  <div data-testid={`faq-row-${i}`} className="border-b border-[#E4E2DA]">
    <button
      type="button"
      onClick={onToggle}
      data-testid={`faq-row-toggle-${i}`}
      className="w-full flex items-start justify-between gap-6 py-6 text-left group"
    >
      <span className="font-serif text-xl lg:text-2xl font-light text-[#3E5239] group-hover:text-[#A7CA99] transition-colors">
        {q}
      </span>
      <span
        className={`text-[#A7CA99] text-2xl shrink-0 mt-1 transition-transform duration-300 ${
          open ? "rotate-45" : ""
        }`}
      >
        +
      </span>
    </button>
    <div
      className={`grid transition-all duration-300 ease-out ${
        open ? "grid-rows-[1fr] opacity-100 pb-6" : "grid-rows-[0fr] opacity-0"
      }`}
    >
      <div className="overflow-hidden">
        <p className="text-[#6B7A66] font-light leading-relaxed max-w-3xl">{a}</p>
      </div>
    </div>
  </div>
);

/** Reusable FAQ accordion. Pass an array of `{ q, a }`. */
export const FaqAccordion = ({ items = [], defaultOpen = 0 }) => {
  const [open, setOpen] = useState(defaultOpen);
  if (!items?.length) return null;
  return (
    <div className="max-w-4xl mx-auto" data-testid="faq-accordion">
      {items.map((it, i) => (
        <FaqRow
          key={it.q}
          q={it.q}
          a={it.a}
          i={i}
          open={open === i}
          onToggle={() => setOpen(open === i ? -1 : i)}
        />
      ))}
    </div>
  );
};
